export default "__VITE_ASSET__da130ebc__"